<ion-content>
  <div class="content">
    <h2>Door te geven order nr. {{data.orderNumber}} </h2>
    <p>Wil je dit order aan onderstaande koerier doorgeven?</p>
    <p>Koerier, {{data.courier.name}}</p>
    <ion-button (click)="confirm()">
      <ion-spinner name="crescent" *ngIf="isPassingOrder"></ion-spinner>
      <div *ngIf="!isPassingOrder">Bevestigen</div>
    </ion-button>
    <ion-button (click)="cancel()">Annuleren</ion-button>
  </div>
</ion-content>